const defaultNoShowButtonAttributes = {
    show: false,
    text: "NA",
    color: "info"
}

export default defaultNoShowButtonAttributes